module.exports = __webpack_public_path__ + "img/DSC_0096.1b694c36.jpg";